import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {UserAvatar} from '../../../../app/modules/auth/components/UserAvatar'
import {KTIcon} from '../../../helpers'

const LogoutConfirmModal: FC<{busy: boolean; onConfirm: () => void; onCancel: () => void}> = ({
  busy,
  onConfirm,
  onCancel,
}) => (
  <>
    <div className='modal-backdrop fade show' onClick={onCancel} />
    <div className='modal fade show d-block' tabIndex={-1}>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fw-bold'>Выйти из аккаунта?</h5>
            <button type='button' className='btn-close' onClick={onCancel} />
          </div>
          <div className='modal-body'>
            <p className='fs-7 mb-0'>Вы уверены, что хотите выйти из своего аккаунта?</p>
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-sm btn-light' onClick={onCancel}>
              Отмена
            </button>
            <button
              type='button'
              className='btn btn-sm btn-primary'
              disabled={busy}
              onClick={onConfirm}
            >
              Выйти
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)

const AsideToolbar = () => {
  const {currentUser, logout} = useAuth()
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [busy, setBusy] = useState(false)

  const handleLogout = async () => {
    setBusy(true)
    await logout()
    setBusy(false)
    setConfirmOpen(false)
  }

  return (
    <>
      {/*begin::User*/}
      <div className='aside-user d-flex align-items-sm-center justify-content-center py-5'>
        {/*begin::Symbol*/}
        <Link to='/wms/profile'>
          <UserAvatar size={50} />
        </Link>
        {/*end::Symbol*/}

        {/*begin::Wrapper*/}
        <div className='aside-user-info flex-row-fluid flex-wrap ms-4'>
          {/*begin::Section*/}
          <div className='d-flex'>
            {/*begin::Info*/}
            <div className='flex-grow-1 me-2'>
              {/*begin::Username*/}
              <Link to='/wms/profile' className='text-white text-hover-primary fs-6 fw-bold'>
                {currentUser?.first_name} {currentUser?.last_name}
              </Link>
              {/*end::Username*/}

              {/*begin::Description*/}
              <span className='text-gray-600 fw-bold d-block fs-8'>
                {currentUser?.occupation}
              </span>
              {/*end::Description*/}
            </div>
            {/*end::Info*/}

            {/*begin::User menu*/}
            <div className='me-n2'>
              {/*begin::Action*/}
              <button
                type='button'
                className='btn btn-icon btn-sm btn-active-color-primary mt-n2'
                title='Выйти'
                onClick={() => setConfirmOpen(true)}
              >
                <KTIcon iconName='exit-right' className='text-muted fs-1' />
              </button>
              {/*end::Action*/}
            </div>
            {/*end::User menu*/}
          </div>
          {/*end::Section*/}
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::User*/}
      {confirmOpen && (
        <LogoutConfirmModal busy={busy} onConfirm={handleLogout} onCancel={() => setConfirmOpen(false)} />
      )}
    </>
  )
}

export {AsideToolbar}
